import type { ISettingsResources } from "@/src/settings/Settings.Resources";

export const SettingsResourcesEn: ISettingsResources = {
    firstLastNameInvalidError: "Podaj imię i nazwisko",
    aliasRequiredError: "Alias is required",
    firstLastNameInvalidCharsError: "Use letters from Polish alphabet: A-Z",
    accountNumberInvalid: "Numer rachunku musi składać się z 26 cyfr",
    bankNameInvalidError: "Invalid account number",
    firstLastNameLabel: "First and last name",
    saveChanges: "Save changes",
    email: "E-mail address",
};
